module.exports = __webpack_public_path__ + "img/ウルティマ・トゥーレ.b2088e6f.png";